import React, { forwardRef } from 'react';
import Typography from '../Typography';
import { HeadingElement, HeadingProps } from '../Typography/types';
import { getResponsiveObject } from './helpers';

const Heading = forwardRef<HTMLElement, HeadingProps>(
  ({ as = 'h1', color = 'heading', fontWeight = 'bold', children, size, ...restProps }: HeadingProps, ref) => {
    const defaultResponsive = getResponsiveObject(as as HeadingElement);

    return (
      <Typography
        ref={ref}
        as={as}
        fontWeight={fontWeight}
        size={size || defaultResponsive}
        color={color}
        {...restProps}
      >
        {children}
      </Typography>
    );
  }
);

Heading.displayName = 'Heading';

export default Heading;
